import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Config } from "../../config";
import { getUrlSettings } from "./ApiService";

const URLRedirection: React.FC = () => {
  const { id: keyName } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const config = new Config();
  const domainOrigin = window.location.origin;
  //const domainOrigin = "testai.connectsform.com";

  useEffect(() => {
    if (!keyName) {
      navigate("*");
      return;
    }

    const fetchUrlSettings = async () => {
      try {
        const response = await getUrlSettings(keyName, domainOrigin);

        if (response?.valueItem) {
          const relativePath = response.valueItem.replace(config.settings.AppUrl, "");
          navigate(relativePath, { replace: true }); // Maintain SPA behavior
        } else {
          navigate("*");
        }
      } catch (error) {
        console.error(`Failed to fetch URL settings: ${error}`);
        navigate("*");
      }
    };

    fetchUrlSettings();
  }, [keyName]);

  return null;
};

export default URLRedirection;
